/**
 * Composants de marque ZeinShop. Swiss K. Strategy.
 *
 * Le carrousel de témoignages : défilement natif avec accroche CSS, le script
 * n'ajoute que le défilement automatique, les flèches, les points, et la
 * synchronisation entre les trois.
 */

(function () {
  'use strict';

  var PAUSE = 4200;

  function monterCarrousel(racine) {
    var piste = racine.querySelector('[data-zein-avis-piste]');
    var prec = racine.querySelector('[data-zein-avis-prec]');
    var suiv = racine.querySelector('[data-zein-avis-suiv]');
    var points = racine.querySelector('[data-zein-avis-points]');
    if (!piste) return;

    var cartes = Array.prototype.slice.call(piste.children);
    if (cartes.length === 0) return;

    // Un point par carte, sauf si la liste est longue : au delà de douze
    // repères, la rangée de points devient illisible et ne sert plus à rien.
    var avecPoints = points && cartes.length <= 12;

    if (avecPoints) {
      cartes.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'zein-avis__point';
        b.setAttribute('aria-label', 'Aller a l avis ' + (i + 1));
        b.addEventListener('click', function () {
          interrompre();
          defilerVers(i);
        });
        points.appendChild(b);
      });
    } else if (points) {
      points.remove();
    }

    function pas() {
      var largeur = cartes[0].getBoundingClientRect().width;
      var ecart = parseFloat(getComputedStyle(piste).columnGap || '0') || 0;
      return largeur + ecart;
    }

    function indexCourant() {
      return Math.round(piste.scrollLeft / pas());
    }

    function finDePiste() {
      return piste.scrollLeft >= piste.scrollWidth - piste.clientWidth - 2;
    }

    function defilerVers(i) {
      piste.scrollTo({ left: i * pas(), behavior: 'smooth' });
    }

    function synchroniser() {
      var i = indexCourant();
      if (prec) prec.disabled = piste.scrollLeft <= 2;
      if (suiv) suiv.disabled = finDePiste();
      if (avecPoints) {
        Array.prototype.slice.call(points.children).forEach(function (p, j) {
          p.setAttribute('aria-current', j === i ? 'true' : 'false');
        });
      }
    }

    /* ------------------------------------------------------------------
       Défilement automatique.

       Il s'arrête définitivement dès que le visiteur touche le carrousel :
       reprendre la main sur quelqu'un qui lit un avis est le meilleur moyen
       de lui faire quitter le bloc. Il est aussi coupé hors écran, et sous
       prefers-reduced-motion.
       ------------------------------------------------------------------ */
    var minuteur = null;
    var interrompu = false;
    var animationReduite = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function avancer() {
      if (interrompu) return;
      if (finDePiste()) {
        piste.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        defilerVers(indexCourant() + 1);
      }
    }

    function demarrerAuto() {
      if (interrompu || animationReduite || minuteur) return;
      minuteur = window.setInterval(avancer, PAUSE);
    }

    function arreterAuto() {
      if (!minuteur) return;
      window.clearInterval(minuteur);
      minuteur = null;
    }

    function interrompre() {
      interrompu = true;
      arreterAuto();
    }

    ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (evt) {
      piste.addEventListener(evt, interrompre, { passive: true });
    });
    racine.addEventListener('mouseenter', arreterAuto);
    racine.addEventListener('mouseleave', demarrerAuto);
    racine.addEventListener('focusin', interrompre);

    // Inutile de faire tourner un minuteur sur un bloc hors de l'écran.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entrees) {
        entrees.forEach(function (e) {
          if (e.isIntersecting) demarrerAuto();
          else arreterAuto();
        });
      }, { threshold: 0.25 }).observe(racine);
    } else {
      demarrerAuto();
    }

    if (prec) {
      prec.addEventListener('click', function () {
        interrompre();
        defilerVers(Math.max(0, indexCourant() - 1));
      });
    }
    if (suiv) {
      suiv.addEventListener('click', function () {
        interrompre();
        defilerVers(Math.min(cartes.length - 1, indexCourant() + 1));
      });
    }

    // Le défilement natif émet beaucoup d'événements : on ne resynchronise
    // qu'une fois la frame rendue, sinon on lit des positions intermédiaires.
    var enAttente = false;
    piste.addEventListener('scroll', function () {
      if (enAttente) return;
      enAttente = true;
      window.setTimeout(function () {
        enAttente = false;
        synchroniser();
      }, 90);
    });

    window.addEventListener('resize', synchroniser);
    synchroniser();
  }

  function demarrer() {
    document.querySelectorAll('[data-zein-avis]').forEach(monterCarrousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();